import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@mui/material'
import { formatAddress, convertShippingInfoToCityStateZip } from 'utils/data-manipulation/valueFormatter'

const PrintLocationInfo = ({ title1, location1, title2, location2 }) => (
  <>
    <Typography variant="h5" pb={1}>
      {title1}
    </Typography>
    <Typography variant="body" sx={{ fontSize: '13px', whiteSpace: 'pre-line' }} mt={1}>
      {`${location1?.name || ''}
        ${formatAddress(
          {
            address: location1?.address1,
            address2: location1?.address2,
          },
          true,
        )}
        ${convertShippingInfoToCityStateZip(location1)}
        ${location1?.phone || ''}
      `}
    </Typography>
    {title2 && (
      <>
        <Typography variant="h5" pb={1}>
          {title2}
        </Typography>
        <Typography variant="body" sx={{ fontSize: '13px', whiteSpace: 'pre-line' }} mt={1}>
          {`${location2?.name || ''}
        ${formatAddress(
          {
            address: location2?.address1 || location2?.address,
            address2: location2?.address2,
          },
          true,
        )}
        ${convertShippingInfoToCityStateZip(location2)}
        `}
        </Typography>
      </>
    )}
  </>
)

PrintLocationInfo.propTypes = {
  title1: PropTypes.string.isRequired,
  location1: PropTypes.object.isRequired,
  title2: PropTypes.string,
  location2: PropTypes.object,
}

PrintLocationInfo.defaultProps = {
  title2: '',
  location2: {},
}

export default PrintLocationInfo
